import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { Typography as d } from "./index59.mjs";
import { Dot as s, Container as c } from "./styles13.mjs";
const g = ({
  label: t,
  color: o,
  icon: n,
  font: p = "Caption",
  variant: e = "standard",
  className: i
}) => {
  const a = d[p];
  return e === "dot" ? /* @__PURE__ */ r(s, { $color: o }) : /* @__PURE__ */ m(c, { $color: o, className: i, children: [
    n,
    /* @__PURE__ */ r(a, { children: t })
  ] });
};
export {
  g as Badge
};
//# sourceMappingURL=index27.mjs.map
